import { Widget } from 'src/dashboard/Componets/Widget';
import { Suspense } from 'react';
import { EntryListWidgetErrorBoundary } from './EntryListWidgetErrorBoundary';
import { WidgetEntryListSuspenseFallback } from './WidgetEntryList';
import { EntryListWidgetSelectAccount } from './EntryListWidgetSelectAccount';

type EntryListWidgetProps = {
  title: string;
  children: (accountRef: string) => React.ReactNode;
  expectedRows: number;
  accountRef: string | null;
};

export const EntryListWidget = ({
  title,
  children,
  expectedRows,
  accountRef,
}: EntryListWidgetProps) => {
  return (
    <Widget title={title}>
      {accountRef ? (
        <EntryListWidgetErrorBoundary key={accountRef}>
          <Suspense fallback={<WidgetEntryListSuspenseFallback rowsCount={expectedRows} />}>
            {children(accountRef)}
          </Suspense>
        </EntryListWidgetErrorBoundary>
      ) : (
        <EntryListWidgetSelectAccount />
      )}
    </Widget>
  );
};
